import api from './api';
import TimeSchedulerModule, { OrderRetrievalMethod } from '@/stores/modules/time-scheduler';
import store from '@/stores/front';
import { getModule } from 'vuex-module-decorators';

export enum TimeSlotState {
    PAST = 'past',
    FULL = 'full',
    AVAILABLE = 'available'
}

export interface TimeSlotInterface {
    start: Date | string;
    end: Date | string;
    state: TimeSlotState;
}

export type TimeSlotResponse = {
    slots: TimeSlotInterface[];
    asap: TimeSlotInterface | null;
    warning: boolean;
};

export default class TimeSlot
{
    _start: Date;
    _end: Date;
    state: TimeSlotState;
    timeSchedulerModule: TimeSchedulerModule;

    constructor(timeSlot: TimeSlotInterface) {
        this._start = new Date(timeSlot.start);
        this._end = new Date(timeSlot.end);
        this.state = timeSlot.state;
        this.timeSchedulerModule = getModule(TimeSchedulerModule, store);
    }

    get start() {
        return (retrievalMethod?: OrderRetrievalMethod) => {
            return this._start;
        }
    }

    get end() {
        return (retrievalMethod?: OrderRetrievalMethod) => {
            return this._end;
        }
    }

    get parsedStart() {
        return this.start().toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
    }

    get parsedEnd() {
        return this.end().toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
    }

    public static async all(): Promise<{slots: TimeSlot[], asap: TimeSlot | null, warning: boolean} | null> {
        const response = await api.get<TimeSlotResponse>({name:'time_slots.index'});
        if (response.success) {
            return {
                slots: TimeSlot.createBatch((<TimeSlotResponse>response.content).slots),
                asap: ((<TimeSlotResponse>response.content).asap !== null) ? new TimeSlot((<TimeSlotResponse>response.content).asap!) : null,
                warning: (<TimeSlotResponse>response.content).warning
            }
        }
        return null;
    }

    public static createBatch(timeSlots: TimeSlotInterface[]): TimeSlot[] {
        let timeSlotInstances = [];
        for (let index = 0; index < timeSlots.length; index++) {
            timeSlotInstances.push(new TimeSlot(timeSlots[index]));
        }
        return timeSlotInstances;
    }
}
